export class Field {
    id: number;
    name: string;
    capacities: FieldCapacity[];
}

export class Facility {
    id: number;
    name: string;
    address: string;
    photo: string;
    fields: Field[];
    facility_sizes: number[];
    h_apertura: number = 8;
    h_cierre: number = 24;
}

export class FieldCapacity {
    id: number;
    description: string;
    display_description: string;
}